module.exports = __webpack_public_path__ + "media/common/text-da-24-f8de2fb5.svg";